module.exports = __webpack_public_path__ + "media/images/ic-number-advisor-439a72eac8b30030a0b39d7d6562466d.svg";